<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-form">
          <div class="card-header">
            <div class="row">
              <div class="col">
<!--                <h4 class="card-title float-left" v-if="companyOrder.id!=null">{{ $t('companyTariff.titleEdit') }}</h4>-->
                <h4 class="card-title float-left">{{$t('companyManage.companyOrder.addNew')}}</h4>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <div class="form-group pr-3">
                  <label>{{ $t('companyManage.companyOrder.companyClient') }}<span class="red">*</span></label>
                  <CompanyClientSelect :value="companyOrder.companyClient"
                                       v-model="companyOrder.companyClient"></CompanyClientSelect>
                  <div class="red" v-if="$v.companyOrder.companyClient.$error">
                    {{ $t('companyManage.companyOrder.companyClient') }}
                  </div>
                </div>
                <div class="form-group pr-3">
                  <label>{{ $t('companyTariff.listTitle') }}<span class="red">*</span></label>
                  <CompanyTariffSelect :value="companyOrder.companyTariff"
                                       v-model="companyOrder.companyTariff"></CompanyTariffSelect>
                  <div class="red" v-if="$v.companyOrder.companyTariff.$error">
                    {{ $t('companyTariff.companyTariffType') }}
                  </div>
                </div>
                <div class="form-group">
                  <label>{{$t('companyManage.companyOrder.feeService')}}: </label><br/>
                  <label class="color-black" v-if="companyOrder.companyTariff && companyOrder.companyTariff.amount">{{companyOrder.companyTariff.amount | currency('', 2, { thousandsSeparator: ' ' })}}</label>
                </div>
                <div class="form-group">
                  <label>{{ $t("report.date.startDate") }}</label>
                  <datepicker
                      class="form-control"
                      format="dd/MM/yyyy"
                      v-model="companyOrder.startDate"
                      :clear-button="true"
                      @input="changeStartDate"
                  ></datepicker>
                  <div class="red" v-if="$v.companyOrder.startDate.$error">
                    {{ $t('companyOrder.startDate') }}
                  </div>
                </div>
                <div class="form-group">
                  <label>{{ $t("report.date.endDate") }}: </label>
                  <label class="font-weight-bold color-black">{{companyOrder.dueDate}}</label>
                </div>
                <div class="form-group">
                  <label>{{ $t('companyTariff.description') }}<span class="red">*</span></label>
                  <textarea
                      cols="30" rows="3"
                      class="form-control"
                      v-model="companyOrder.description"
                  ></textarea>
                </div>


              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12 btns-box">
                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                  {{ $t("action.cancel") }}
                </button>
                <button class="all-btn add-btn" @click="save"
                        :disabled="processing" v-if="save">
                  {{ $t("action.save") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import Datepicker from 'vuejs-datepicker';
import initFilterModel from '@/shared/filter';
// import DatePicker from 'vuejs-datepicker';
import {formatDate, parseDate} from '@/shared/utils';
import CompanyTariffSelect from '@/views/company/company-personal-cabinet/CompanyTariffSelect'
import CompanyClientSelect from '@/views/company/company-personal-cabinet/CompanyClientSelect'
// import {BASE_API} from '@/axios';

export default {
  name: "CompanyTariffAddEditView",
  components: {
    CompanyTariffSelect,
    CompanyClientSelect,
    Datepicker
  },
  data() {
    return {
      parseDate: parseDate,
      formatDate: formatDate,
      processing: false,
      loading: {
        isDocQrLoading: false,
      },
      ownerFilter: initFilterModel(),
      editIndex: null,
      loadingExcelCalc: false,
      companyOrder: {
        id: null,
        startDate: null,
        dueDate: null,
        description: null,
      },
      itemFilter: initFilterModel(),
      results: null
    }
  },
  validations() {
    return {
      companyOrder: {
        companyClient: {
          required: required
        },
        companyTariff: {
          required: required
        },
        startDate: {
          required: required
        },
        dueDate: {
          required: required
        }
      }
    }
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;

      if (id && id > 0) {
        this.$http.get('/company-order/' + id)
            .then(res => {
              console.log(res);
              vm.companyOrder = res.data;
              this.processing = false;
            }, () => {
              this.$swal({
                title: this.$t('messages.common.error'),
                text: this.$t('messages.fixedExpense.error'),
                type: 'error'
              });
              this.processing = false;
            });
      } else {
          var d = new Date();
          var currMonth = d.getMonth();
          var currYear = d.getFullYear();
          this.companyOrder.startDate = new Date(currYear, currMonth, 1);
          this.companyOrder.dueDate = new Date(currYear, currMonth+1, 1);
      }
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.processing = true;
      this.$http.post('/company-order/save', this.companyOrder)
          .then(res => {
            console.log(res)
            const status = res.data.status;
            if (status==='SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: res.data.message,
                type: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: res.data.message,
                type: 'warning'
              });
            }
            this.$router.push('/company-manage/company-personal-cabinet');
            this.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.companyOrder.error'),
              type: 'error'
            });
            this.processing = false;
          })

    },
    cancel() {
      this.$router.push('/company-manage/company-personal-cabinet');
    },
    changeStartDate(/*$event*/) {
        var d = this.companyOrder.startDate;
        var currMonth = d.getMonth();
        var currYear = d.getFullYear();
        this.companyOrder.dueDate = new Date(currYear, currMonth+1, d.getDate());

        console.log(this.companyOrder.dueDate);

      // if (this.companyOrder.startDate >= this.companyOrder.dueDate) {
      //   // this.companyOrder.startDate = this.companyOrder.endDate;
      //   this.$swal({
      //     title: this.$t('messages.common.warning'),
      //     text: formatDate(this.companyOrder.endDate) + ' дан олдинги сана танлаш мумкин эмас',
      //     type: 'warning'
      //   });
      // }
    }

  },
  computed: {

  },
  created() {
    this.init();
  }
}
</script>

<style scoped>
.custom {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.custom td, .custom th {
  border: 1px solid #ddd;
  padding: 4px;
}

.custom tr:nth-child(even) {
  background-color: #f2f2f2;
}

.custom tr:hover {
  opacity: 1;
  background-color: #dee2e6;
}

.custom thead tr th {
  border-bottom-width: 1px;
  padding-top: 4px;
  padding-bottom: 4px;
  text-align: center !important;
  color: #9A9A9A;
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: 400;
}

.custom tr {
  font-size: 14px;
}

</style>